<template lang="html">
  <article class="">
    <section>
      <h3 style="text-align: center">Nuevo Tag</h3>
      <v-text-field
        name="name"
        label="Nombre"
        type="text"
        v-model="tag.attributes.natural_name"></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        color="blue"
        @click="createTag()">Crear</v-btn>
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      tag:{
        attributes:{
          natural_name: '',
          published: true
        }
      }

    }
  },
  methods:{
    createTag(){
      if(this.tag.attributes.natural_name != '' &&
         this.tag.attributes.natural_name != undefined &&
         this.tag.attributes.natural_name != null){
        try {
          this.$http.post('tags', {data: this.encrypt(this.tag).toString()},
            {headers:
              {"X-Device-ID" : this.getDeviceId(),
               "Authorization" : 'Bearer ' + this.getUserToken()}})
          .then(function(response){
            this.$router.push({name: 'tag'})
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            // alert(response);
          })
        } catch (e) {
          alert(e.message)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/tags/New_tag.vue